import React from "react";
import { Link } from "react-router-dom";

const CommunityRules = () => {
  return (
    <div className="legal-page page-shell">
      <div className="card legal-card">
        <h1>Community Rules</h1>
        <p className="muted">Last updated: May 4, 2026</p>

        <p>
          MyFarmingPal is built for farmers, landowners, workers, homesteaders,
          vendors, event hosts, and local communities. These rules help keep the
          platform useful, honest, and safe.
        </p>

        <h2>1. Be Honest</h2>
        <p>
          Do not post false, misleading, fake, exaggerated, or deceptive
          listings, prices, photos, locations, job details, product details,
          reviews, or profile information.
        </p>

        <h2>2. Be Respectful</h2>
        <p>
          Harassment, threats, abuse, hate speech, impersonation, intimidation,
          bullying, sexual harassment, and discriminatory conduct are not
          allowed.
        </p>

        <h2>3. Keep Listings Legal and Safe</h2>
        <p>
          Do not use MyFarmingPal to sell, request, promote, or arrange illegal,
          stolen, counterfeit, dangerous, restricted, or unsafe goods or
          services.
        </p>

        <h2>4. Job Posting Rules</h2>
        <p>
          Job posts should clearly describe the work, location, pay or bid
          structure, timing, needed equipment, safety concerns, and expectations.
          Users are responsible for complying with applicable labor, tax,
          safety, licensing, environmental, animal welfare, and agricultural
          laws.
        </p>

        <p>
          Job posts and work arrangements involving minors must be handled by
          responsible adults and must follow all applicable labor, child labor,
          safety, agricultural, and local laws. Do not post or arrange unsafe,
          illegal, misleading, exploitative, or inappropriate work.
        </p>

        <h2>5. Marketplace Rules</h2>
        <p>
          Product listings should be accurate and include truthful details about
          price, quantity, condition, availability, pickup, delivery, and any
          relevant product information. Do not list stolen, unsafe, illegal, or
          misrepresented products.
        </p>

        <h2>6. Event Rules</h2>
        <p>
          Event hosts are responsible for accurate event details, vendor spot
          availability, permits, venue rules, payment handling, safety, and
          legal compliance.
        </p>

        <h2>7. Reviews</h2>
        <p>
          Reviews must be based on real interactions. Do not post fake reviews,
          paid reviews, retaliatory reviews, threats, private personal
          information, or irrelevant comments.
        </p>

        <h2>8. Messaging</h2>
        <p>
          Do not use messaging for spam, scams, harassment, illegal activity,
          phishing, threats, or abusive communication.
        </p>

        <h2>9. Reporting Problems</h2>
        <p>
          If you see a suspicious listing, unsafe request, abusive message, fake
          review, scam, or rule violation, please report it through our{" "}
          <Link to="/contact">Contact page</Link>.
        </p>

        <h2>10. Enforcement</h2>
        <p>
          We may remove content, restrict features, suspend accounts, or
          terminate access if we believe a user has violated these rules or
          created risk for other users or the platform.
        </p>
      </div>
    </div>
  );
};

export default CommunityRules;
